import { makeStyles } from "@material-ui/core"

export default makeStyles(() => ({
    navigationButtonBox: {
        padding: 15,
        margin: 15,
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    navigationButtonButton: {
        position: "absolute",
        height: "100%",
        zIndex: 1
    },
    keyboardArrow: {
        color: "white"
    },
    thumbNailStepper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    thumbNailStepperMain: {
        display: "flex",
        justifyContent: "center",
        position: "relative"
    },
    thumbNailIndicator: {
        width: "30px",
        height: "30px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    thumbNailIndicatorCircle: {
        width: 12.5,
        height: 12.5,
        borderRadius: "50%"
    }
}))
